/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { CosmosSeoFragment } from "@cosmos/hygraph-schema";
import { LocaleMessages } from "@epic-mw/i18n";
import { Metadata } from "next";

import { getAlternates } from "./alternates";

const DEFAULT_TITLE_REGEX = new RegExp(`([\\|-] ${process.env.APP_DEFAULT_TITLE_SUFFIX})$`, "gi");

export const rootLayoutMetadata = {
	title: {
		template: `%s - ${process.env.APP_DEFAULT_TITLE_SUFFIX}`,
		default: process.env.APP_DEFAULT_TITLE_PREFIX, // a default is required when creating a template
	},
	metadataBase: process.env.EPIC_SERVER_URL,
};

export const postProcessMetaDataTitle = (title?: string | null): string => {
	if (title) {
		//The Suffix is appended automatically via the template.
		// Here we remove it to prevent double appending.
		// Also remove an accidental double hyphen
		return title
			.replace(DEFAULT_TITLE_REGEX, "")
			.replace(" -  - ", " - ")
			.replace(/(\w-)$/g, "");
	} else {
		// Let top level layout.tsx assign the DEFAULT_TITLE
		return "";
	}
};

export const getNextMetadata = (
	metaTags: CosmosSeoFragment,
	slug: string,
	locale: string,
	getMessages: (locale: string) => LocaleMessages,
	appDefaultImage: string,
): Metadata => {
	const messages = getMessages(locale) || {};
	const localeSlug = `/${locale}${slug}`;

	const title = metaTags.title || messages["epic.app.meta.title"] || process.env.APP_DEFAULT_TITLE;
	const description = metaTags.description || messages["epic.app.meta.description"] || "";
	const socialTitle = metaTags.socialTitle || title;
	const defaultImage =
		appDefaultImage || "https://cdn2.unrealengine.com/epic-games-social-share-1200x675-7670432fc58a.png";

	return {
		title: postProcessMetaDataTitle(title),
		description,
		alternates: getAlternates(locale, slug),
		openGraph: {
			title: socialTitle,
			description: metaTags.socialDescription || description,
			url: localeSlug,
			type: "article",
			locale,
			siteName: process.env.APP_DEFAULT_TITLE_SUFFIX,
			images: [
				{
					url: metaTags.openGraphImage?.url || defaultImage,
				},
			],
		},
		twitter: {
			title: socialTitle,
			description: metaTags.socialDescription || description,
			site: process.env.APP_TWITTER_SITE,
			images: [
				{
					url: metaTags.openGraphImage?.url || defaultImage,
				},
			],
		},
		robots: {
			index: metaTags.noIndex ? false : true,
			follow: metaTags.noFollow ? false : true,
			"max-image-preview": "large",
			googleBot: {
				index: metaTags.noIndex ? false : true,
				follow: metaTags.noFollow ? false : true,
				"max-image-preview": "large",
			},
		},
	};
};
